import React from 'react';
import styles from '../../css/components/forms/textInputHints.css';
import PropTypes from 'prop-types';

export default function TextInputHints({ hintMessages, gameId, pageType }) {
	return (
		<div
			className={`${styles.hint} ${styles[pageType]} ${styles[gameId]}`}
			data-testid="hints"
		>
			{hintMessages && hintMessages.length > 0 && hintMessages.map((el, i) => {
				return(<p key={i}>{el}</p>);
			})}
			<div className={styles.arrow}></div>
		</div>
	);
}

TextInputHints.propTypes = {
	hintMessages: PropTypes.array.isRequired,
	pageType: PropTypes.string.isRequired,
	gameId: PropTypes.string.isRequired,
};
